import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-4">
      <FaExclamationTriangle size={64} className="text-warning mb-3" />
      <h1 className="display-4 fw-bold">404</h1>
      <p className="lead text-muted mb-4">Oops! The page you're looking for doesn't exist.</p>
      <button onClick={() => navigate(-1)} className="btn btn-primary">
        Go Back
      </button>
    </div>
  );
};

export default NotFound;
